import React from 'react'
import { Container } from '@shared/components/container'
import { ListItemPageLink } from '@shared/components/list-item-page-link'
import { RegionalLinks } from '@shared/components/regional-links'
import { PageConfig } from 'admin/types'
import { pagesTitles } from 'data/pages-titles'
import { useRegions } from 'regions/provider'

import regionsData from '../../regions/json/regions.json'

import { Props } from './model'

import styles from './style.module.scss'

const View = ({ isRegional, pagesFromAdminPanel }: Props) => {
	const { currentCity } = useRegions()

	const getAllRegionLinks = () => {
		return Object.values(regionsData).map((city) => (
			<ListItemPageLink
				key={city.key}
				region={city.key}
				path={''}
				isRegional
				title={city?.displayName}
			/>
		))
	}

	const getNotRegionalLinks = () => {
		return Object.entries(pagesTitles).map(([key, value]) => (
			<ListItemPageLink key={key} path={key} title={value.mainBlockTitle || value.title} />
		))
	}

	const getAdminPages = () => {
		const regionalPages = [] as any[]
		const pages = [] as any[]

		pagesFromAdminPanel.forEach((page) => {
			if (page.isRegional) {
				const nameWithRegion = `${page.name} в %city_pr%`
				regionalPages.push({ ...page, name: nameWithRegion })
			} else {
				pages.push(page)
			}
		})

		return { regionalPages, pages }
	}

	const { regionalPages, pages } = getAdminPages()

	const getAdminPageLinks = (pages: PageConfig[]) => {
		return pages?.map(({ name, url, isRegional }) => (
			<ListItemPageLink key={url} path={url} title={name} isRegional={isRegional} />
		))
	}

	const mainHeader = `Карта сайта ${isRegional ? `- ${currentCity?.displayName}` : ''}`

	return (
		<Container className='mt-xl mb-xl'>
			<h1 className={styles.mainHeading}>{mainHeader}</h1>
			{isRegional && (
				<>
					<h2 className={styles.heading}>{`Кредиты и займы в ${currentCity.grammems.pr}`}</h2>
					<RegionalLinks />
					<div className={styles.row}>{getAdminPageLinks(regionalPages)}</div>
				</>
			)}
			<h2 className={styles.heading}>{'Кредиты и займы в других городах'}</h2>
			{getAllRegionLinks()}
			<div className={styles.row}>{getNotRegionalLinks()}</div>
			<div className={styles.row}>{getAdminPageLinks(pages)}</div>
		</Container>
	)
}

export default View
